import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { CountiesFilters, CountySlice } from "./countiesTypes.ts";

const initialState: CountySlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const countiesSlice = createSlice({
  name: "counties",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<CountySlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<CountySlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof CountiesFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<CountySlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  countiesSlice.actions;

export const selectPage = (state: RootState) => state.counties.page;
export const selectRowsPerPage = (state: RootState) =>
  state.counties.rowsPerPage;
export const selectFilter = (state: RootState) => state.counties.filter;
export const selectSort = (state: RootState) => state.counties.sort;

export default countiesSlice.reducer;
